<template>
	<span
		:style="avatar ? `background-image: url(${avatar})` : 'background-image: none'"
		class="sb-dropdown-menu-button user-avatar add-hover-overlay">
		<span v-if="!avatar">
			{{ userName | initials }}
		</span>
		<span
			v-if="availabilityToggleShown"
			:class="[userAvailable ? 'green' : 'red']"
			class="indicator"/>
	</span>
</template>

<style lang="scss" scoped>

</style>

<script>
/**
 * TODO
 * Component loads user details and shows avatar, name and availability.
 * IS THIS USED ANYWHERE ???
 */

export default {
	name: 'UserAvatar',
}
</script>